module.exports = __webpack_public_path__ + "media/images/flags/1x1/brn-eb7f25b9a5f2f42a9f89073a8f0d1434.svg";